<template>
    <div class="droplayer icon filter-box board-list-b relative">
        <v-menu offset-y :close-on-content-click="false" v-model="filterShow">
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" :class="filterCount > 0 ? 'sel' : ''">필터</v-btn>
            </template>
            <div class="dropdown-list cnt board">
                <div class="dropdown-list_header">
                    {{ $i18nUtil.trans("search.filter.001","{cnt}건 선택", {cnt: filterCount}) }}
                    <button type="button" class="btn-refresh" v-if="filterCount > 0" @click="filterClear">새로고침</button>
                </div>
                <div class="cnt_inner clear">
                    <div class="cnt-folder">
                        <div class="tit">{{ $i18nUtil.trans("message.filter.001","카테고리") }}</div>
                        <div class="nodata" v-if="categoryList == null || categoryList.length == 0"><div class="txt">{{ $i18nUtil.trans("message.filter.002","등록된 카테고리가 없습니다.") }}</div></div>
                        <ul>
                            <li v-for="(item, idx ) in categoryList" :key="'category_'+idx">
                                <input type="checkbox" name="" 
                                       :id="'folder5_'+idx" 
                                       v-model="selectedCategoryList" 
                                       :value="item.categoryMid"><label :for="'folder5_'+idx">{{item.categoryName}}</label>
                            </li>
                        </ul>
                    </div>
                    <div class="cnt-option">
                        <div class="tit">{{ $i18nUtil.trans("message.filter.003","상세 옵션") }}</div>
                        <ul>
                            <li 
                                v-for="(categoryGradeItem, categoryGradeItemIndex) in boardGradeList"
                                :key="categoryGradeItem.gradeCode + '_' + categoryGradeItemIndex"
                            >
                                <input type="checkbox" name="" 
                                :id="`chkCategoryGradeId`+categoryGradeItemIndex" 
                                v-model="selectedBoardGradeCodeList"
                                :value="categoryGradeItem.gradeCode"
                                /><label :for="`chkCategoryGradeId`+categoryGradeItemIndex">{{categoryGradeItem.gradeName}}</label>
                            </li>
                        </ul>
                    </div>
                    <div class="cnt-evaluation">
                        <div class="tit">{{ $i18nUtil.trans("message.filter.004","상태") }}</div>
                        <ul>
                            <li 
                            v-for="(boardStatusItem, boardStatusItemIndex) in boardStatusList"
                            :key="boardStatusItem.gradeCode + '_' + boardStatusItemIndex"
                            :class="'ico-txt-' +
                            (boardStatusItem.status === 'GOOD' ? 'evaluate-good' 
                            : boardStatusItem.status === 'SO' ? 'evaluate-so' 
                            : boardStatusItem.status === 'DELAY' ? 'evaluate-delay' : 'evaluate-exceeded')"
                        >
                            <input type="checkbox" name="" 
                            :id="`bChkBoardStatusId`+boardStatusItemIndex" 
                            v-model="selectedBoardStatusCodeList"
                            :value="boardStatusItem.status"
                            /><label :for="`bChkBoardStatusId`+boardStatusItemIndex">
                                {{boardStatusItem.statusName}}
                            </label>
                        </li>
                        </ul>
                    </div>
                    <!-- <div class="cnt-editor">
                        <div class="tit">생성/수정자</div>
                        <ul>
                            <li><input type="checkbox" name="" id="all2"><label for="all2">전체</label></li>
                            <li><input type="checkbox" name="" id="na1me1"><label for="na1me1">김한화</label></li>
                            <li><input type="checkbox" name="" id="na1me2" checked><label for="na1me2">이생명이이생명이</label></li>
                            <li><input type="checkbox" name="" id="na1me3"><label for="na1me3">김한화</label></li>
                            <li><input type="checkbox" name="" id="na1me4"><label for="na1me4">이생명이이생명이</label></li>
                            <li><input type="checkbox" name="" id="na1me5"><label for="na1me5">이생명이이생명이</label></li>
                            <li><input type="checkbox" name="" id="na1me6"><label for="na1me6">김한화</label></li>
                            <li><input type="checkbox" name="" id="na1me7"><label for="na1me7">이생명이이생명이</label></li>
                        </ul>
                    </div> -->
                </div>
                <div class="dropdown-list_foot">
                    <button type="button" class="btn-primary-small" @click="recoverFilter">{{ $i18nUtil.trans("button.filter.cancel","취소") }}</button>
                    <button type="button" class="btn-primary-small black" @click="applyFilter">{{ $i18nUtil.trans("button.filter.apply","적용") }}</button>
                </div>
                <!-- <div class="info">필터는 중복 선택이 가능합니다.</div> -->
            </div>
        </v-menu>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
export default {
    props:["categoryList","initFilter"],
    data() {
        return {
            show: false,
            filterCount: 0,
            selectedCategoryList:[],
            selectedBoardGradeCodeList:[],
            selectedBoardStatusCodeList :[],
            boardGradeList: this.isChineseWallUse ? [
                                                    {gradeCode: 'NORMAL', gradeName: this.$i18nUtil.trans("entity.paper.docGrade.NORMAL","전체공개")}
                                                    , {gradeCode: 'RESTRICT', gradeName: this.$i18nUtil.trans("entity.paper.docGrade.RESTRICT","멤버만 공개")}
                                                    , {gradeCode: 'SECRET', gradeName: this.$i18nUtil.trans("entity.paper.docGrade.SECRET","비공개")}
                                                    ]
                                                   :[
                                                    {gradeCode: 'RESTRICT', gradeName: this.$i18nUtil.trans("entity.paper.docGrade.RESTRICT","멤버만 공개")}
                                                    , {gradeCode: 'SECRET', gradeName: this.$i18nUtil.trans("entity.paper.docGrade.SECRET","비공개")}
                                                    ] ,
            boardStatusList: [
                {status: 'GOOD', statusName: this.$i18nUtil.trans("entity.paper.paperStatus.GOOD","정상")}
                , {status: 'SO', statusName: this.$i18nUtil.trans("entity.paper.paperStatus.SO","이슈 발생")}
                , {status: 'DELAY', statusName: this.$i18nUtil.trans("entity.paper.paperStatus.DELAY","보고 필요")}
                , {status: 'EXCEEDED', statusName: this.$i18nUtil.trans("entity.paper.paperStatus.EXCEEDED","종료")}
            ],
            prevSelectedCategoryList : [],
            prevSelectedBoardGradeCodeList : [],
            prevSelectedBoardStatusCodeList: [],
            filterShow: false,
            filterApply: false,

            //정보차단벽 체크
            isChineseWallUse:false
        };
    },
    created() {
        if(this.isCooperation == 'cooperation') {
            this.checkPolicy();
        }
    },
    watch:{
        filterShow: {
            handler() {
                let obj = this;
                setTimeout(()=> {
                    if(!obj.filterShow && !obj.filterApply) {
                        obj.selectedCategoryList = obj.prevSelectedCategoryList;
                        obj.selectedBoardGradeCodeList = obj.prevSelectedBoardGradeCodeList;
                        obj.selectedBoardStatusCodeList = obj.prevSelectedBoardStatusCodeList;
                    }
            
                    if(obj.filterApply) {
                        obj.filterApply = false;
                    }
                }, 50);
            }
        },
        selectedCategoryList: {
            handler() { 
                this.filterCount = this.selectedCategoryList.length + this.selectedBoardGradeCodeList.length + this.selectedBoardStatusCodeList.length;
            }
        },
        selectedBoardGradeCodeList: {
            handler() {
                this.filterCount = this.selectedCategoryList.length + this.selectedBoardGradeCodeList.length + this.selectedBoardStatusCodeList.length;
            }
        },
        selectedBoardStatusCodeList: {
            handler() {
                this.filterCount = this.selectedCategoryList.length + this.selectedBoardGradeCodeList.length + this.selectedBoardStatusCodeList.length;
            }
        },
        filterReset: {
            handler() {
                let obj = this;
                if(this.$props.filterReset) {
                obj.prevSelectedCategoryList = [];
                obj.prevSelectedBoardGradeCodeList = [];
                obj.prevSelectedBoardStatusCodeList = [];
                obj.filterClear();
                }
            }
        },
        initFilter: {
            handler() {
                let obj = this;
                if(obj.initFilter.categoryMidCodeList.length != 0){ /*  && initFilter.gradeCodeList.length != obj.boardGradeList.length */
                    this.selectedCategoryList = this.initFilter.categoryMidCodeList;
                    this.prevSelectedCategoryList = this.initFilter.categoryMidCodeList;
                }
                if(obj.initFilter.gradeCodeList.length != 0){ /*  && initFilter.gradeCodeList.length != obj.boardGradeList.length */
                    this.selectedBoardGradeCodeList = this.initFilter.gradeCodeList;
                    this.prevSelectedBoardGradeCodeList = this.initFilter.gradeCodeList;
                }
                if(obj.initFilter.statusCodeList.length != 0){ /*  && initFilter.gradeCodeList.length != obj.boardGradeList.length */
                    this.selectedBoardStatusCodeList = this.initFilter.statusCodeList;
                    this.prevSelectedBoardStatusCodeList = this.initFilter.statusCodeList;
                }
                this.filterShow = false;
                this.filterApply = true;
            }
        }
    },
    methods:{
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        // 필터 새로고침
        filterClear() {
            let obj = this;
            obj.selectedCategoryList = [];
            obj.selectedBoardGradeCodeList = [];
            obj.selectedBoardStatusCodeList = [];
        },
        // 필터 취소
        recoverFilter() {
            let obj = this;
            // 필터 되돌림
            obj.selectedCategoryList = obj.prevSelectedCategoryList;
            obj.selectedBoardGradeCodeList = obj.prevSelectedBoardGradeCodeList;
            obj.selectedBoardStatusCodeList = obj.prevSelectedBoardStatusCodeList;
            obj.filterShow = false;
            obj.filterApply = false;
        },
        // 필터 적용
        applyFilter() {
            let obj = this;
            // 필터 변경
            obj.prevSelectedCategoryList = obj.selectedCategoryList;
            obj.prevSelectedBoardGradeCodeList = obj.selectedBoardGradeCodeList;
            obj.prevSelectedBoardStatusCodeList = obj.selectedBoardStatusCodeList;
            obj.filterShow = false;
            obj.filterApply = true;
            let rtnSelectedCategoryList = obj.selectedCategoryList.length == 0 ? [] : obj.selectedCategoryList;
            let rtnSelectedBoardGradeCodeList = obj.selectedBoardGradeCodeList.length == 0 ? [] : obj.selectedBoardGradeCodeList;
            let rtnSelectedBoardStatusCodeList = obj.selectedBoardStatusCodeList.length == 0 ? [] :obj.selectedBoardStatusCodeList;
            
            let categoryCheckYn = true;
            let gradeCheckYn  = true;
            let statusCheckYn  = true;

            if(obj.selectedCategoryList.length == 0) {
                categoryCheckYn = false;
                obj.categoryList.forEach((elem)=> {
                    rtnSelectedCategoryList.push(elem.categoryMid);
                });
            }
            if(obj.selectedBoardGradeCodeList.length == 0) {
                gradeCheckYn = false;
                obj.boardGradeList.forEach((elem)=> {
                    rtnSelectedBoardGradeCodeList.push(elem.gradeCode);
                });
            }
            if(obj.selectedBoardStatusCodeList.length == 0){
                statusCheckYn = false;
                obj.boardStatusList.forEach((elem)=>{
                    rtnSelectedBoardStatusCodeList.push(elem.status);
                })
            }

            obj.$emit('updateCommonFilterC', 
                        {
                            filterCategoryList: rtnSelectedCategoryList, 
                            filterGradeList: rtnSelectedBoardGradeCodeList,
                            filterStatusList : rtnSelectedBoardStatusCodeList,
                            categoryCheckYn : categoryCheckYn,
                            gradeCheckYn : gradeCheckYn,
                            statusCheckYn : statusCheckYn
                        });
        },
        checkPolicy(){
            let obj = this;
            let reqData = {
                url : "/api/org/getCodeValueList",
                method : "post",
                params : {
                cdCategory: 'tenant.env',
                cdKey: 'chinese.wall.use'
                }
            };
            this
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
                if(res.result[0].cdValue == 'true'){
                    // 전체 공개 메뉴 숨김.
                    obj.isChineseWallUse = true;
                }
            })
            .catch(function(err) {
                console.log(err);
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/common/filter/CommonFilterC.vue